define('domReady',[],function () {
    return function (cb) {
        if (document.readyState == 'complete') {
            cb();
        } else {
            window.addEventListener('load', function () {
                cb();
            });
        }
    };
});
